/**
 * System field mappings for contacts
 * These are the standard fields that CSV columns can be mapped to
 */
export const SYSTEM_FIELD_MAPPINGS = [
  { name: "First Name", mapping: "first_name", required: true },
  { name: "Last Name", mapping: "last_name", required: false },
  { name: "Email", mapping: "email", required: true },
  { name: "Company Name", mapping: "company_name", required: false },
  { name: "Address", mapping: "address", required: false },
  { name: "City", mapping: "city", required: false },
  { name: "State", mapping: "state", required: false },
  { name: "Postal Code", mapping: "postal_code", required: false },
  { name: "Phone", mapping: "phone", required: false },
];

/**
 * Contact source options
 */
export const CONTACT_SOURCES = {
  CSV: "csv",
  DATABASE: "database",
};

/**
 * Default field mappings state
 */
export const DEFAULT_FIELD_MAPPINGS = {
  first_name: "",
  last_name: "",
  email: "",
  company_name: "",
  address: "",
  city: "",
  state: "",
  postal_code: "",
  phone: "",
};

/**
 * Email binding origins
 */
export const BINDING_ORIGINS = {
  EVENT: "EVENT",   // Value comes from contact object (dynamic per recipient)
  FIXED: "FIXED",   // Static value for all recipients
};

/**
 * Default email payload fields
 */
export const DEFAULT_EMAIL_PAYLOAD = [
  { field: "from", value: "" },
  { field: "sender_name", value: "" },
  { field: "to", value: "{{To}}" },
  { field: "subject", value: "" },
  { field: "cc", value: "" },
  { field: "bcc", value: "" },
  { field: "body", value: "" },
];

/**
 * Default email bindings
 */
export const DEFAULT_EMAIL_BINDINGS = [
  { name: "To", variable: "{{To}}", origin: "EVENT", value: "email" },
];

/**
 * Maximum file size for CSV upload (100MB)
 */
export const MAX_FILE_SIZE_MB = 100;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

/**
 * Allowed file types for CSV upload
 */
export const ALLOWED_FILE_TYPES = ["text/csv", "application/vnd.ms-excel"];

/**
 * Pagination defaults for database contacts
 */
export const PAGINATION_DEFAULTS = {
  PAGE_SIZE: 20,
  INITIAL_PAGE: 1,
};
